<script lang="ts" setup></script>
<template>
  <div class="flex items-center justify-center mt-10">
    <div class="w-72 bg-base-100">
      <figure>
        <img
          class="mx-auto"
          src="../assets/images/unauthorized.svg" />
      </figure>

      <div class="card-body items-center text-center">
        <h2 class="card-title text-error">접근 권한이 없습니다.</h2>
        <p class="text-2xl">😵</p>
      </div>
    </div>
  </div>
</template>
